import { useQuery } from "@tanstack/react-query";
import { adminTenantSubscriptionsService } from "@/services/admin-tenant-subscriptions-service";

const subscriptionTenantOptionKeys = {
  all: ["subscription-tenant-options"] as const,
};

export const useSubscriptionTenantOptions = (enabled: boolean) =>
  useQuery({
    queryKey: subscriptionTenantOptionKeys.all,
    queryFn: () => adminTenantSubscriptionsService.getTenantOptions(),
    staleTime: 60 * 1000,
    enabled,
  });
